import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — T-junction wall piece: a full straight wall along X plus a
// half-length arm toward +Z, all meeting at the tile centre. Same plaster +
// baseboard styling as wall-plain.
const PLASTER = "#e8e4dc";
const BASEBOARD = "#c9c2b6";

export const wallT = defineModel({
  id: "wall-t",
  batchId: "modern",
  name: "Wall T-junction",
  tags: ["modern", "interior", "structure", "wall", "junction"],
  summary: "A T-junction wall: full run along X plus a half-arm toward +Z.",
  description:
    "The T piece of the Modern Living wall system: a full one-tile plastered " +
    "wall along X (0.12 m thick, 2.6 m high) with a half-length (0.5 m) arm " +
    "branching toward +Z from the tile centre. Rotate in 90-degree steps to " +
    "orient; straight wall tiles continue any of the three arms.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // full wall along X
      { geometry: new THREE.BoxGeometry(1.0, 2.6, 0.12), color: PLASTER, position: [0, 1.3, 0] },
      // half-arm toward +Z
      { geometry: new THREE.BoxGeometry(0.12, 2.6, 0.5), color: PLASTER, position: [0, 1.3, 0.25] },
      // baseboards
      { geometry: new THREE.BoxGeometry(1.0, 0.1, 0.15), color: BASEBOARD, position: [0, 0.05, 0] },
      { geometry: new THREE.BoxGeometry(0.15, 0.1, 0.5), color: BASEBOARD, position: [0, 0.05, 0.25] },
    ];
  },
  animations: [],
});
